import { HelpText } from 'src/components/atoms/HelpText/HelpText';
import styled from 'styled-components';

export const ParameterDropdownStyled = styled.div<{ column: number }>`
  grid-column-start: ${(props) => props.column};
`;

export const StyledHelpText = styled(HelpText)`
  align-items: start;
`;
